module.exports = __webpack_public_path__ + "img/emitter.b0bedd86.png";